import { useLocation } from 'react-router';
import OnboardingContainer from '$src/components/OnboardingContainer';
import useLocationContext from '$src/hooks/useLocationContext';
import { redirectToOnboardingRingSolutionsProfessionalMonitoring } from '$src/utils/redirect';
import { handleBackToRingDashboard } from '$src/utils/handleBack';
import useStores from '$src/hooks/useStores';
import useFeature from '$src/hooks/useFeature';
import { MonitoringSettingsIcon } from '@ring-icons';
import emergencyVehiclesImg from '$src/assets/img/onboardingEmergencyVehicles.png';
import { PROFESSIONAL_MONITORING } from './constants';

import './ProfessionalMonitoring.less';

function ProfessionalMonitoring() {
  const locationId = useLocationContext();
  const { state } = useLocation();
  const {
    sessionStore: { isMobile },
  } = useStores();
  const [is1pModelEnabled] = useFeature('stark-feature-next-1P-model');
  
  return (
    <OnboardingContainer
      headerTitle={PROFESSIONAL_MONITORING.HEADER_TITLE}
      className="professional-monitoring"
      icon={MonitoringSettingsIcon}
      title={PROFESSIONAL_MONITORING.TITLE}
      image={emergencyVehiclesImg}
      data-testid="professional-monitoring"
      subtitle={is1pModelEnabled ? PROFESSIONAL_MONITORING.SUBTITLE_1P_MODEL : PROFESSIONAL_MONITORING.SUBTITLE}
      primaryText={PROFESSIONAL_MONITORING.PRIMARY_TEXT}
      handleClose={() => handleBackToRingDashboard(isMobile)}
      hideBack
      primaryActionHandler={() => redirectToOnboardingRingSolutionsProfessionalMonitoring(locationId)}
      alert={state?.error}
      warningOnClose
    />
  );
}
export default ProfessionalMonitoring;
